interface LanguagePack {
    [lang: string]: {
        [key: string]: string; // 내부 객체에 대한 인덱스 시그니처 추가
    };
}

const languagePack : LanguagePack = {
    'ko': {
        'tooltip': '이미지 그리기',
        'header_title' : '이미지 그리기'
    },
    'en': {
        'tooltip': 'Draw image',
        'header_title' : 'Draw image'
    }
};

// string | undefined 반환 타입 명시
export default function getDrawExString(key: string, lang: string): string | undefined {
    // 안전한 접근과 함께, 존재하지 않는 경우 undefined 반환
    if (languagePack[lang] && languagePack[lang][key]) {
        return languagePack[lang][key];
    }
    return undefined; // or you can return a default string or handle the error as needed
}
